import AxiosService from '../AxiosService';

const GetGeneralClientInfo = async (): Promise<IRootClientData> => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/general');
  return response.data;
};

const GetNotificationInfo = async () => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/notifications');
  return response.data;
};

const GetCommertialInfo = async () => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.get('/v1/client/commercial');
  return response.data;
}


const updatePasswordPost = async (data: IPasswords) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.put('/v1/client/update-password', {
    ...data,
  });
  return response.data;
};
const createNewPassword = async (data: IPasswords) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.post('/v1/client/update-password', {
    ...data,
  });
  return response.data;
};

const createNewContact = async (data: IContact) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.put('/v1/client/update-info-contact', {
    ...data,
  });
  return response.data;
};

const updateNotificationsPreference = async data => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.put('/v1/client/notifications', {
    ...data,
  });
  return response.data;
};

const desactivateAccount = async (password) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.post('/v1/client/desactivate-account', {
    password
  });
  return response.data;
};

const updatePicture = async (formData, clientCode: string) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.post(
    'v1/client/update-picture',
    {data: formData},
    {
      headers: {
        Accept: 'application/json',
        'client-code': clientCode,
        'x-device-id': 'stuff',
        'Content-Type': 'multipart/form-data',
      },
    },
  );
  return response.data;
};

const createOneSignalSubscription = async (playerId: string, clientCode: string) => {
  const instance = AxiosService.createAuthAxiosInstance();
  const response = await instance.post('/v1/client/push', {
    playerId,
    clientCode,
  });
  return response.data;
}
// const updatePicture = async (formData, clientCode) => {
//   const instance = AxiosService.createAuthAxiosInstance();

//   const response = await instance.post(
//     'v1/client/update-picture',
//     formData, // Envia o FormData diretamente para permitir a criação do boundary
//     {
//       headers: {

//         'client-code': clientCode,
//         // O 'Content-Type' será definido automaticamente como 'multipart/form-data' com boundary
//       },
//     }
//   );

//   return response.data;
// };

export default {
  GetCommertialInfo,
  GetNotificationInfo,
  GetGeneralClientInfo,
  updatePasswordPost,
  createNewPassword,
  updateNotificationsPreference,
  updatePicture,
  createOneSignalSubscription,
  createNewContact,
  desactivateAccount
};
